import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { Link } from '@alfa-bank/site-link';
import cn from 'classnames';

import type { TSectionLink } from './models';

export const SectionLink: FC<PropsWithChildren<TSectionLink>> = ({
    DataLayer,
    Text,
    analytics,
    children,
    className,
    href,
    styles,
    textConfigs,
    type,
}) => {
    if (type === 'section') {
        return (
            <Text
                className={cn(styles.external, styles[type], styles.text, className)}
                {...textConfigs[type].text}
            >
                {children}
            </Text>
        );
    }

    return (
        <>
            <Text
                {...textConfigs[type].text}
                className={cn(
                    styles.external,
                    styles[type as keyof typeof styles],
                    styles.text,
                    className
                )}
            >
                <Link
                    href={href}
                    {...textConfigs[type].link}
                    className={cn(styles.external, styles.link)}
                    noUnderline
                >
                    <DataLayer data={analytics} tag={null}>
                        {children}
                    </DataLayer>
                </Link>
            </Text>
        </>
    );
};
